var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseIcon',{staticClass:"i-icon",style:(_vm.myStyle),attrs:{"type":_vm.type,"theme":_vm.theme,"spin":_vm.spin,"rotate":_vm.rotate,"component":_vm.component,"twoToneColor":_vm.twoToneColor},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }